import { CATALOGUE_MODE } from "@constants";

import React from "react";
import "react-loading-skeleton/dist/skeleton.css";

import { Router } from "@components/Router";

import KioskPreview from "./KioskPreview";

export function App(): JSX.Element {
    if (process.env.REACT_APP_MODE === CATALOGUE_MODE) {
        return (
            <KioskPreview>
                <Router />
            </KioskPreview>
        );
    }
    return <Router />;
}
